import { styled } from '@mui/material';
import { GoogleMap, MarkerF, CircleF, InfoWindowF, useJsApiLoader } from '@react-google-maps/api';
import { useState } from 'react';
import { circleOptions, defaultCenter } from './static';
import { GMapsPlaceMarkerProps } from './types';
import { VisibilityEnum } from '../dictionaries/LocationVisibility';
import ImageCardGMap from '../Cards/ImageCardGMap';

function GMapsPlaceMarker(props: GMapsPlaceMarkerProps) {
  const {
    visibilityOption = VisibilityEnum.Visible,
    height = '100%',
    onSubmitFavorite = () => undefined,
    location = undefined, 
    zoom = 7,
    center = (location?.lat, location?.lng)
      ? props.location
      : defaultCenter
  } = props;    
  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker: any) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const MyMarker = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    padding: 0.3, 
    boxShadow: '0 2px 7px 1px rgba(0,0,0, 0.3)'
  });
  
  const randomizeLocation = (location: { lat: number, lng: number } 
    | google.maps.LatLngLiteral, radius: number) => {
    const y0 = location.lat;
    const x0 = location.lng;
    const rd = radius / 111300; //about 111300 meters in one degree
  
    const u = Math.random();
    const v = Math.random();
  
    const w = rd * Math.sqrt(u);
    const t = 2 * Math.PI * v;
    const x = w * Math.cos(t);
    const y = w * Math.sin(t);
  
    //Adjust the x-coordinate for the shrinking of the east-west distances
    const xp = x / Math.cos(y0);
  
    const newlat = y + y0;
    const newlon = xp + x0;
    return { lat: newlat, lng: newlon };
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    // libraries: ['geometry', 'drawing'],
  });

  return (<>
    {isLoaded && <GoogleMap
      options={{
        draggable: true
      }}
      onClick={() => setActiveMarker(null)}
      mapContainerStyle={{
        height: height,
        width: '100%',
        borderRadius: '10px'
      }}
      zoom={zoom}
      center={center} 
    >
      {Array.isArray(location) ?
        location.map((loc: any, index: any) => {                    
          return (
            <>
              {visibilityOption === VisibilityEnum.Hidden
                ? null
                : <MarkerF
                  key={index}
                  position={loc.visibilityOption === VisibilityEnum.Sample
                    ? randomizeLocation(loc.location, 12)
                    : loc}
                  onClick={() => handleActiveMarker(index)}>
                  {activeMarker === index && 
                    <InfoWindowF
                      position={loc}
                      onCloseClick={() => setActiveMarker(null)}>
                      <MyMarker>
                        <ImageCardGMap card={loc}
                          onSubmitFavorite={onSubmitFavorite}
                        />
                      </MyMarker>      
                    </InfoWindowF>}
                </MarkerF> 
              }
            </>
          );
        }) 
        : 
        <>
          {visibilityOption === VisibilityEnum.Visible ?
            location ?
              <MarkerF 
                position={location}
              >
              </MarkerF>
              : null
            : (visibilityOption === VisibilityEnum.Sample)
              ? location 
                ? <CircleF
                  center={randomizeLocation(location, 50)}
                  options={circleOptions}
                />
                : null
              : null
          }
        </> 
      }
    </GoogleMap>
    }
  </>);
}

export default GMapsPlaceMarker;